import type { NextWorkflowError } from 'models/NextWorkflowError';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { HttpCall, IHttpClient } from 'utils/http/httpClient.model';
export interface AvailableTag {
  key: string;
  label: string;
  default?: boolean;
}

export interface ILifeRingApi {
  sendMail: (request: ISendMailRequest) => Observable<HttpCall<void>>;
  getAvailableTags: () => Observable<readonly AvailableTag[]>;
}

export interface ISendMailRequestLegacy {
  content: string;
  notifications?: string[];
}

export interface ISendMailSmartQuote {
  promptId: string;
  quoteId: string;
  negotiationId?: string;
  rejectionMessage?: string;
}

export interface ISendMailRequest {
  userMessages: string[];
  notifications?: string[];
  tags: readonly string[];
  errors?: readonly NextWorkflowError[];
  currentRoute?: string;
  pricerId?: string;
  externalQuoteId?: string;
  quoteId?: string;
  orderId?: string;
  productKey?: string;
  fileCode?: string;
  isinCode?: string;
  productId?: string;
  tradeId?: string;
  dealId?: string;
  screenShot?: string;
  width?: number;
  height?: number;
  negotiationId?: string;
  basketOptimizerId?: string;
  basketOptimizerError?: string;
  batchColumns?: { quoteId?: string; negotiationId?: string }[];
  smartQuotes?: ISendMailSmartQuote[];
}
export const TechnicalTag = 'Technical';

export function lifeRingApiConnector(http: IHttpClient): ILifeRingApi {
  return {
    sendMail: request => {
      return http.post({
        url: 'api/v2/help-request/send',
        body: request,
      });
    },
    getAvailableTags: () => {
      return http
        .getJSON<{ data: readonly AvailableTag[] }>({
          url: `api/v1/help-request/available-tags`,
        })

        .pipe(
          map(response => {
            return response.payload?.data ?? [];
          }),
        );
    },
  };
}
